import React, {
    useEffect,
    useRef
} from 'react';

import {
    useLocation
} from 'react-router-dom';

import {
    ANALYTICS_V2_EVENTS,
    trackAnalyticsV2
} from '../../utils/analyticsV2/analyticsV2';

import {
    ensurePageView
} from '../../utils/analyticsV2/identityManager';

import {
    resolveAnalyticsPageType
} from '../../utils/analyticsV2/pageContext';

import {
    startAnalyticsSender,
    stopAnalyticsSender
} from '../../utils/analyticsV2/analyticsSender';

const AnalyticsV2Bootstrap = () => {
    const location =
        useLocation();

    const lastTrackedPageViewIdRef =
        useRef(null);

    useEffect(() => {
        startAnalyticsSender();

        return () => {
            stopAnalyticsSender();
        };
    }, []);

    useEffect(() => {
        const pageView =
            ensurePageView(
                location.pathname
            );

        if (
            lastTrackedPageViewIdRef
                .current ===
            pageView.pageViewId
        ) {
            return;
        }

        trackAnalyticsV2(
            ANALYTICS_V2_EVENTS
                .PAGE_VIEW,
            {
                pageType:
                    resolveAnalyticsPageType(
                        location.pathname
                    )
            }
        )
            .then(
                eventId => {
                    if (eventId) {
                        lastTrackedPageViewIdRef
                            .current =
                            pageView.pageViewId;
                    }
                }
            );

    }, [
        location.pathname
    ]);

    return null;
};

export default AnalyticsV2Bootstrap;